<template>
    <div class="container my-5" v-if="cat">
        <div class="mv_category_head"><div class="d-flex"><h1><font-awesome-icon @click="$router.go(-1)" icon="arrow-left" style="font-size: 24px;vertical-align:middle;cursor:pointer" /> {{cat.name}}</h1></div><a @click="expandAll = !expandAll" class="text-primary">{{expandAll ? 'Vista semplice' : 'Mostra tutto'}}</a></div>
        <div class="box">
            <h3 style="margin:1em;">Prodotti</h3>
         <CategoryCatalog :category="cat" :first="true" :expanded="true" :expandAll="expandAll"/>

        </div>
    </div>
</template>
<script>

import CategoryCatalog from '../components/CategoryCatalog'
export default {

    data () {
        return {
            expandAll: false
        }
    },
  

    computed: {
        cat() {
            return this.$store.getters.categories.find(c => c.id && c.id == this.$route.params.id)
        },
    },
    components: {
        CategoryCatalog
    }
}
</script>
<style lang="scss" scoped>
@import '@/styles/style.scss';

    .mv_category_head {
        box-sizing: border-box;
        padding: 1em;
        align-items: center;
    }


</style>